// extracted by mini-css-extract-plugin
export default {"base":"Compare_base__rrlgv","stepsContainer":"Compare_stepsContainer__SPpAK"};